import { render } from "./InputLocalGoals.vue?vue&type=template&id=19d0f258"
import script from "./InputLocalGoals.vue?vue&type=script&lang=js"
export * from "./InputLocalGoals.vue?vue&type=script&lang=js"
script.render = render

export default script